import { initContract } from '@ts-rest/core';
import { adminDrawOrderContract } from './drawOrder.admin.contract';
import { authDrawOrderContract } from './drawOrder.auth.contract';

const c = initContract();

export const drawOrderContract = c.router(
  {
    auth: authDrawOrderContract,
    admin: adminDrawOrderContract,
  },
  {
    pathPrefix: '/draw/order',
    strictStatusCodes: true,
  }
);

export * from './drawOrder.admin.contract';
export * from './drawOrder.auth.contract';
export * from './models';

